import axios from 'axios';
import 'promise-polyfill/src/polyfill';

const AdaApi = function (baseUrl) {
    baseUrl = baseUrl || window.hubConfig.baseUrl;

    const axiosClient = axios.create({
        //withCredentials: true
    });

    this.loginUser = data => {
        const url = `${baseUrl}/SignIn`;
        const config = {
            headers: {
                'Ocp-Apim-Subscription-Key': window.hubConfig.apiId || ''
            }
        };
        const response = axiosClient.post(url, data, config);
        return response;
    };

    this.loginUserByToken = (token, data) => {
        const url = `${baseUrl}/SignInByToken`;
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Ocp-Apim-Subscription-Key': window.hubConfig.apiId || ''
            }
        };
        const response = axiosClient.post(url, data, config);
        return response;
    };

    this.validate = (data) => {
        const url = `${baseUrl}/Validate`;
        const token = window.hubCookie.getToken();
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Ocp-Apim-Subscription-Key': window.hubConfig.apiId || ''
            }
        };
        const response = axiosClient.post(url, data, config);
        return response;
    };
};

export default AdaApi;


// WEBPACK FOOTER //
// ./src/nams2020/common/api/adaAPI.js